import React from 'react';

type ARSixteenByNineIconProps = {};

function ARSixteenByNineIcon({}: ARSixteenByNineIconProps) {
  return (
    <svg
      width='12'
      height='4'
      viewBox='0 0 12 4'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='12' height='4' rx='1' fill='#737373' />
    </svg>
  );
}

export default ARSixteenByNineIcon;
